"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoSettingsModal = VideoSettingsModal;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _VideoSettingsDialog = require("../VideoSettingsDialog");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
function VideoSettingsModal(_ref) {
  var muted = _ref.muted,
      playbackRate = _ref.playbackRate,
      zoomed = _ref.zoomed,
      locked = _ref.locked,
      loopMomentPlay = _ref.loopMomentPlay,
      videoSettingsDialogOpen = _ref.videoSettingsDialogOpen,
      setVideoSettingsDialogOpen = _ref.setVideoSettingsDialogOpen,
      handleVideoSettingsChange = _ref.handleVideoSettingsChange,
      videoSettingsKey = _ref.videoSettingsKey,
      setLocked = _ref.setLocked,
      setLoop = _ref.setLoop;
  var el = document.getElementById("modal-root");

  if (!el) {
    el = document.createElement("div");
    el.id = "modal-root";
    document.body.appendChild(el);
  }

  return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_VideoSettingsDialog.VideoSettingsDialog, {
    muted: muted,
    speed: playbackRate,
    locked: locked,
    zoomEnabled: zoomed,
    loopMomentPlay: loopMomentPlay,
    setLoop: setLoop,
    setLocked: setLocked,
    open: videoSettingsDialogOpen,
    videoSettingsKey: videoSettingsKey,
    onClose: function onClose(e) {
      return setVideoSettingsDialogOpen(false);
    },
    onConfirmSettingsChange: handleVideoSettingsChange
  }), el);
}